import React, { useEffect, useState } from "react";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import api from "../Axios";
import moment from "moment/moment";
import FirstButton from "../common/button";
import { useNavigate } from "react-router-dom";
import {
  FacebookShareButton,
  LinkedinShareButton,
  WhatsappShareButton,
} from "react-share";
import { FacebookIcon, LinkedinIcon, WhatsappIcon } from "react-share";
const Blog = () => {
  const navigate = useNavigate();
  const [blogData, setBlogData] = useState([]);
  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls to the top of the page
  }, []);
  useEffect(() => {
    getBlogData();
  }, []);
  const getBlogData = () => {
    api
      .post("get-all-blog")
      .then((resp) => {
        setBlogData(resp?.data?.data);
      })
      .catch((err) => console.log(err));
  };

  return (
    <div className="search">
      <h1 className="primary_title text-center about_heading">Blog</h1>

      {/* <p style={{ textAlign: "center" }} className="fs-18 my-2">
        Get in touch and let us know how we can help you
      </p> */}

      <div
        style={{
          flexWrap: "wrap",
          display: "flex",
          gap: "20px",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {blogData &&
          blogData.map((blog) => {
            const shareUrl = `${window.location.origin}/blog-details/${blog._id}`;
            return (
              <div
                key={blog._id}
                className="ncs_card"
                style={{ borderRadius: "6px" }}
                //  onClick={() => navigate(`/blog-details/${blog._id}`)}
              >
                <div className="p-2">
                  <img
                    src={blog.image}
                    className="imgclass"
                    style={{
                      objectFit: "cover",
                      height: "250px",
                      minHeight: "250px",
                      borderTopLeftRadius: "6px",
                      borderTopRightRadius: "6px",
                      width: "100%",
                    }}
                  />
                </div>
                <div className="p-2 px-4">
                  <div
                    className="dflex"
                    style={{ justifyContent: "space-between" }}
                  >
                    <div
                      className="dflex align-center vpil"
                      style={{ width: "fit-content", gap: "8px" }}
                    >
                      <CalendarMonthIcon />
                      <p className="ms-2 mb-0 fs-14">
                        {moment(blog.publishedAt).format("MMM Do YY")}
                      </p>
                    </div>
                    <div>
                      {/* WhatsApp Share Button */}
                      <WhatsappShareButton
                        url={shareUrl}
                        title={blog.title}
                        className="mx-3"
                      >
                        <WhatsappIcon size={24} round />
                      </WhatsappShareButton>

                      {/* LinkedIn Share Button */}
                      <LinkedinShareButton url={shareUrl} title={blog.title}>
                        <LinkedinIcon size={24} round />
                      </LinkedinShareButton>
                    </div>
                  </div>
                  <p
                    className="mt-2 mb-3 fs-20 fw-700"
                    style={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {blog.title}
                  </p>
                  <p
                    className="mb-2 fs-14 fw-500 content-preview"
                    dangerouslySetInnerHTML={{ __html: blog.content }}
                  ></p>
                </div>
                <div className="d-flex justify-content-end mb-3 px-4">
                  <FirstButton
                    className="btn-contact"
                    buttonText="Read more"
                    marginTop="2rem"
                    width="50%"
                    onClick={() => navigate(`/blog-details/${blog._id}`)}
                  />
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default Blog;
